import type { Overview_IncidentsQuery } from '~/types/graphql/graphql';
import { OVERVIEW_INCIDENTS_QUERY_LIST_FROM_TWO_DATES } from '../../graphql/incident';

export const overviewWeeklyRepository = () => {
  // Composables
  const { apolloClient } = useApollo();

  // Store
  const { areas } = areaStore();

  const getIncidents = async (start: Date, end: Date) => {
    const areaIds = areas.map((area) => area.id);
    const { data } = await apolloClient.query<Overview_IncidentsQuery>({
      query: OVERVIEW_INCIDENTS_QUERY_LIST_FROM_TWO_DATES,
      variables: { start, end, areaIds },
    });
    return data.incidents;
  };

  return {
    getIncidents,
  };
};
